import { render, staticRenderFns } from "./Param.vue?vue&type=template&id=06478fee&scoped=true&"
import script from "./Param.vue?vue&type=script&lang=ts&"
export * from "./Param.vue?vue&type=script&lang=ts&"
import style0 from "./Param.vue?vue&type=style&index=0&id=06478fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06478fee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VSelect})
